import Vue from 'vue'
import { mapMutations } from 'vuex'

export default {
  methods: {
    ...mapMutations([
      'SET_AVAILABLE_UPDATE'
    ]),
    updateVersion () {
      if (window.navigator) {
        window.navigator.serviceWorker.getRegistrations()
          .then((registrations) => {
            registrations.forEach((item) => {
              item.unregister()
            })
            this.SET_AVAILABLE_UPDATE(false)
            Vue.prototype.$nextTick(() => {
              document.location.reload(true)
            })
          })
      } else {
        console.error('Service Worker is not available!')
        Vue.addToastDanger('Não foi possível atualizar. Tente novamente!')
      }
    }
  }
}
